import { MyVoucherRow, Tag } from '../../../types'
import TagChips from '../../Tags/TagChips'
import { Link } from 'react-router-dom'
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'
import { GenericColumnDef } from '../DataTable'
import VoucherStateBadge from '../VoucherStateBadge'
import VoucherCommentsBadge from '../VoucherCommentsBadge'
import PaymentAccountBadges from '../PaymentAccountBadges'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import theme from '../../../theme'
import { formatPaymentDate, formatPeriod } from '../../../utils/utils'

export const getVouchersColumns = (
  requestDelete: (id: string) => void,
  onTagClick?: (tag: Tag) => void,
): GenericColumnDef<MyVoucherRow>[] => [
  {
    id: 'expander',
    header: () => null,
    cell: ({ row }) =>
      row.getCanExpand() ? (
        <button
          onClick={row.getToggleExpandedHandler()}
          style={{ cursor: 'pointer', border: 'none', background: 'none' }}
        >
          {row.getIsExpanded() ? (
            <FaCaretDown color={theme.palette.primary.main} />
          ) : (
            <FaCaretRight color={theme.palette.primary.main} />
          )}
        </button>
      ) : null,
    size: 40,
  },
  {
    accessorKey: 'reference_number',
    header: 'Reference #',
    cell: ({ row }) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <PaymentAccountBadges voucher={row.original} />
        <Link to={`/panel/vouchers/${row.original.id}/edit`}>
          {row.original.reference_number ?? 'Draft'}
        </Link>
        <VoucherCommentsBadge voucher={row.original} />
      </div>
    ),
    filterFn: 'includesString',
    size: 20,
  },
  { accessorFn: (row) => row.department.name, header: 'Department', size: 20 },
  {
    accessorFn: (row) =>
      row.submitted_at
        ? new Date((row.submitted_at as number) * 1).toISOString().split('T')[0]
        : '',
    header: 'Submitted At',
    size: 80,
  },
  {
    accessorFn: (row) =>
      row.created_by.first_name + ' ' + row.created_by.last_name,
    header: 'Prepared by',
    size: 200,
  },
  {
    accessorKey: 'state',
    header: 'State',
    cell: ({ row }) => <VoucherStateBadge state={row.original.state} />,
    size: 10,
  },
  {
    id: 'tags',
    header: 'Tags',
    cell: ({ row }) => (
      <TagChips tags={row.original.tags} onTagClick={onTagClick} />
    ),
    size: 120,
  },
  {
    accessorFn: (row) => row.pay_to,
    header: 'Pay amount to',
    size: 200,
  },
  {
    accessorFn: (row) => formatPaymentDate(row.paid_by_amin),
    header: 'Payment',
    enableColumnFilter: false,
    size: 80,
  },
  {
    accessorFn: (row) => formatPeriod(row.expense_period),
    header: 'Expense Month',
    size: 80,
  },
  {
    accessorFn: (row) =>
      new Intl.NumberFormat('en-SE', {
        style: 'currency',
        currency: row.currency,
      }).format(row.total_amount),
    header: 'Amount',
    enableColumnFilter: false,
    meta: { align: 'right' },
    size: 120,
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) =>
      row.original.is_created_by_me && row.original.state === 'DRAFT' ? (
        <IconButton
          size="small"
          color="error"
          onClick={(e) => {
            e.stopPropagation()
            requestDelete(row.original.id)
          }}
        >
          <DeleteIcon />
        </IconButton>
      ) : null,
  },
]
